import "core-js/stable"
import "regenerator-runtime/runtime"
import React, { useState } from 'react'
import PropTypes from "prop-types"
import styles from "./Header.scss"

const propTypes = {
  sponsorId: PropTypes.number.isRequired,
  staffName: PropTypes.string.isRequired,
}

const Header = (props) => {
  const [display, setDisplay] = useState(false)
  const editSponsorSponsorPath = `/sponsor/settings/${props.sponsorId}/edit`
  const editSponsorAccountPath = `/sponsor/account/edit`
  const agenyRootPath = `/agency`
  const staffSiginoutPath = `/staff/sign_out`
  const contaienrActive = styles.items_container_active
  const itemActive = styles.items_active
  const backgroundActive = styles.background_active

  return (
    <header>
      <div className={styles.outer_container}>
        <div className={styles.container}>
          <div
            className={`${styles.items_container} ${display ? contaienrActive : ""}`}
            onClick={() => setDisplay(!display)}
          >
            {props.staffName}
            <span></span>

            <div className={`${styles.items} ${display ? itemActive : ""}`}>
              <a href={editSponsorSponsorPath}>
                <div>会社設定</div>
              </a>
              <a href={editSponsorAccountPath}>
                <div>アカウント設定</div>
              </a>
              { props.hasAgency &&
                <a href={agenyRootPath}>
                  <div>事務所画面に切り替え</div>
                </a>
              }
              <a href={staffSiginoutPath} data-method="delete">
                <div>ログアウト</div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div
        className={`${styles.background} ${display ? backgroundActive : ""}`}
        onClick={() => setDisplay(!display)}
      />
    </header>
  )
}

Header.propTypes = propTypes

export default Header
